import React from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import { Paper, useTheme } from '@mui/material';
import HorizontalStackedLineChart from '../../../../Components/Charts/HorizontalStackedLineChart';
import { FullSizeColumn } from '../../../../Components/FlexBox';
import CaptionValue from '../../../../Components/CaptionValue/CaptionValue';
import { formatThousands } from '../../../../Utils/constants/general';
import TooltipContent from '../../../WaveManagement/Components/SimulationsHistory/Pages/SimulationSummaries/Components/TooltipContent';

const SectionTotalsPaper = function SectionTotalsPaper({
  totalFiltersCount,
  filteredCount,
  contactableCount,
  filterDetails = [],
  onClick,
  selected,
}) {
  const translate = useTranslate();
  const theme = useTheme();

  const colors = theme.custom.generateConsistentUniqueColors(
    filterDetails.map((d) => d?.filterName)
  );

  const horizontalBarData = filterDetails.map(
    ({ filterReason, filterName, count }, index) => ({
      id: filterReason?.toString(),
      label: translate(filterName),
      value: count,
      color: colors[index]?.[theme.palette.mode],
    })
  );

  const horizontalTotal = horizontalBarData.reduce(
    (acc, curr) => acc + curr.value,
    0
  );

  return (
    <Paper
      sx={{
        padding: '20px',
        cursor: 'pointer',
        outline: selected ? `2px solid ${theme.palette.primary.main}` : 'none',
      }}
      onClick={onClick}
    >
      <FullSizeColumn gap="20px">
        <CaptionValue
          caption="LOADED"
          value={formatThousands(totalFiltersCount)}
          direction="row"
          width="100%"
          valueColor="#607d8b"
          captionColor="textPrimary"
          captionStyle={{ flexGrow: 1, fontSize: '1rem' }}
          valueStyle={{ fontSize: '1.5rem' }}
        />
        <CaptionValue
          caption="FILTERED"
          value={formatThousands(filteredCount)}
          direction="row"
          width="100%"
          valueColor="#607d8b"
          captionColor="textPrimary"
          captionStyle={{ flexGrow: 1, fontSize: '1rem' }}
          valueStyle={{ fontSize: '1.5rem' }}
        />
        <CaptionValue
          caption="CONTACTABLE"
          value={formatThousands(contactableCount)}
          direction="row"
          width="100%"
          valueColor="#607d8b"
          captionColor="textPrimary"
          captionStyle={{ flexGrow: 1, fontSize: '1rem' }}
          valueStyle={{ fontSize: '1.5rem' }}
        />

        <HorizontalStackedLineChart
          data={horizontalBarData}
          total={horizontalTotal}
          height={36}
          TooltipContent={(props) => (
            <TooltipContent total={horizontalTotal} {...props} />
          )}
        />
      </FullSizeColumn>
    </Paper>
  );
};
export default SectionTotalsPaper;
